import { toast } from "react-toastify";
import APIPaths from "../../utils/APIPaths";
import axiosInstance from "../axiosInstance";

export const getCasePaperDefList = async (
  organizationId,
  formType,
  clientId,
) => {
  try {
    const URL = APIPaths.GET_CASE_PAPER_DEF_BY_ORGANIZATION_ID;

    const response = await axiosInstance.get(URL, {
      params: {
        organizationId: organizationId,
        category: formType,
        clientId: clientId,
      },
    });
    if (response.status === 200) {
      return response.data;
    }
    return [];
  } catch (error) {}
};

export const addCasePaperAnswer = async (reqBody) => {
  try {
    const URL = APIPaths.SAVE_CASE_PAPER_ANSWER;
    const response = await axiosInstance.post(URL, reqBody, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    if (response.status === 200) {
      toast.success("Successfully submitted.");
      return response;
    }
  } catch (error) {
    if (error.response.data) {
      toast.error(error.response.data);
    }
    return error.response.data;
  }
};

export const getCasePaperBySearch = async (
  pattern,
  clientId,
  date,
  category,
) => {
  try {
    const URL = APIPaths.SEARCH_CASE_PAPER;
    const response = await axiosInstance.get(URL, {
      params: {
        pattern: pattern,
        clientId: clientId,
        date: date,
        category: category,
      },
    });

    if (response.status === 200 || response.status === 204) {
      return response;
    }
    return [];
  } catch (error) {}
};

export const getCasePaperByClientId = async (clientId, category) => {
  try {
    const URL = APIPaths.GET_FIVE_CASE_PAPER_BY_ID;
    const response = await axiosInstance.get(URL, {
      params: {
        clientId: clientId,
        category: category,
      },
    });
    if (response.status === 200 || response.status === 204) {
      return response;
    }
    return [];
  } catch (error) {}
};

export const getCasePaperByCasePaperId = async (casePaperId) => {
  try {
    const URL = APIPaths.GET_CASE_PAPER_BY_CASE_PAPER_ID + casePaperId;
    const response = await axiosInstance.get(URL);
    if (response.status === 200 || response.status === 204) {
      return response;
    }
    return [];
  } catch (error) {}
};

export const uploadCasePaperCsvService = async (data) => {
  const response = await axiosInstance
    .post(APIPaths.ADD_CASE_PAPER, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      if (error.code === "ERR_NETWORK" || error.response.status === 500) {
        toast.error("Something went wrong");
        return { status: 500 };
      }
      return error.response;
    });
  return response;
};

export const uploadClientAdditionalInfoService = async (data) => {
  const response = await axiosInstance
    .post(APIPaths.UPLOAD_CLIENT_ADDITIONAL_INFO, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      if (error.code === "ERR_NETWORK" || error.response.status === 500) {
        toast.error("Something went wrong");
        return { status: 500 };
      }
      return error.response;
    });
  return response;
};

export const downloadSampleClientAdditionalInfoCsv = async () => {
  try {
    const URL = APIPaths.DOWNLOAD_SAMPLE_CLIENT_ADDITIONAL_INFO_CSV;
    const response = await axiosInstance.get(URL, {
      responseType: "arraybuffer",
      headers: {
        "Content-Type": "application/json",
        Accept: "text/csv",
      },
    });
    if (response.status === 200) {
      toast.success("Sample CSV downloaded successfully");
      const url = window.URL.createObjectURL(new Blob([response.data]));
      return url;
    } else if (response.status === 204) {
      toast.warning("Sample CSV not available");
    }
  } catch (error) {
    toast.error("Sample CSV download failed");
  }
};

export const downloadSampleCasePaper = async () => {
  try {
    const URL = APIPaths.DOWNLOAD_SAMPLE_CASE_PAPER_ZIP_FOLDER;
    const response = await axiosInstance.get(URL, {
      responseType: "arraybuffer",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/zip",
      },
    });
    if (response.status === 200) {
      toast.success("Sample ZIP folder downloaded successfully");
      const url = window.URL.createObjectURL(new Blob([response.data]));
      return url;
    } else if (response.status === 204) {
      toast.warning("Sample ZIP folder not available");
    }
  } catch (error) {
    toast.error("Sample ZIP folder download failed");
  }
};

export const downloadSCasePaperCsvById = async (id) => {
  try {
    const URL = APIPaths.DOWNLOAD_CASE_PAPER_DEF_CSV_BY_ID + id;
    const response = await axiosInstance.get(URL, {
      responseType: "arraybuffer",
      headers: {
        "Content-Type": "application/json",
        Accept: "text/csv",
      },
    });
    if (response.status === 200) {
      toast.success("Case Paper downloaded successfully");
      const url = window.URL.createObjectURL(new Blob([response.data]));
      return url;
    } else if (response.status === 204) {
      toast.warning("Case Paper not available");
    }
  } catch (error) {
    toast.error("Case Paper download failed");
  }
};

export const downloadClientAdditionalInfoById = async (id) => {
  try {
    const URL = APIPaths.DOWNLOAD_CLIENT_ADDITIONAL_INFO_BY_ID + id;

    const response = await axiosInstance.get(URL, {
      responseType: "array-buffer",
      headers: {
        "content-Type": "application/json",
        Accept: "text/csv",
      },
    });
    if (response.status === 200) {
      toast.success("Patient's Additional Information downloaded successfully");
      const url = window.URL.createObjectURL(new Blob([response.data]));
      return url;
    } else if (response.status === 204) {
      toast.warning("Patient's Additional Information not available");
    }
  } catch (error) {}
};

export const deleteClientAdditionalDefCsvById = async (id) => {
  try {
    const URL = APIPaths.DELETE_CLIENT_ADDITIONAL_INFO_DEF_BY_ID + id;
    const response = await axiosInstance.delete(URL);

    if (response && response.status === 200) {
      toast.success("Patient's Additional Information deleted successfully.");
      return response;
    } else {
      toast.error("Something went wrong.");
      return response;
    }
  } catch (error) {
    if (error.response && error.response.data) {
      toast.error(error.response.data);
    } else {
      toast.error("Something went wrong.");
    }
  }
};

export const deleteCasePaperDefCsvById = async (id) => {
  try {
    const URL = APIPaths.DELETE_CASE_PAPER_DEF_CSV_BY_ID + id;
    const response = await axiosInstance.delete(URL);

    if (response.status === 200) {
      toast.success("Case Paper deleted successfully.");
      return response;
    } else {
      toast.error("Something went wrong.");
      return response;
    }
  } catch (error) {
    return error;
  }
};

export const getImportedCasePaperDefList = async () => {
  try {
    const URL = APIPaths.GET_CASE_PAPER_DEF_LIST;
    const response = await axiosInstance.get(URL);
    if (response.status === 200) {
      return response.data;
    }
    return [];
  } catch (error) {}
};

export const updateCasePaperStatus = async (casePaperId) => {
  try {
    const URL = APIPaths.STATUS_CHANGE_CASE_PAPER_DEF_BY_ID + casePaperId;
    const response = await axiosInstance.put(URL);
    if (response.status === 200) {
      return response;
    } else {
      toast.error(response);
      return [];
    }
  } catch (error) {
    toast.error(error.response.data);
    return [];
  }
};

export const downloadCasePaperPDF = async (
  casePaperId,
  data,
  categoryId,
  category,
) => {
  try {
    const URL = `${APIPaths.DOWNLOAD_CASE_PAPER_PDF_BY_CASE_PAPER_ID}${casePaperId}/${categoryId}/${category}`;
    const response = await axiosInstance.post(URL, data, {
      responseType: "arraybuffer",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    if (response.status === 200) {
      toast.success("Case Paper PDF Downloaded Successfully");
      const url = window.URL.createObjectURL(new Blob([response.data]));
      return url;
    } else if (response.status === 204) {
      toast.warning("Case Paper Not Available");
    }
  } catch (error) {
    toast.error("Case Paper PDF Download failed");
  }
};

export async function viewCasePaperByCasePaperId(
  casePaperId,
  data,
  categoryId,
  category,
) {
  try {
    const URL = `${APIPaths.DOWNLOAD_CASE_PAPER_PDF_BY_CASE_PAPER_ID}${casePaperId}/${categoryId}/${category}`;
    const response = await axiosInstance.post(URL, data, {
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/pdf",
      },
    });

    if (response.status === 200) {
      const url = window.URL.createObjectURL(response.data);
      return url;
    }
  } catch (error) {
    toast.error("View file failed");
  }
}

export const getCasePaperByAppointmentId = async (appointmentId) => {
  try {
    const URL = APIPaths.GET_CASE_PAPER_BY_APPOINTMENT_ID + appointmentId;
    const response = await axiosInstance.get(URL);
    if (response.status === 200 || response.status === 204) {
      return response;
    }
    return [];
  } catch (error) {}
};

export const updateCasePaperDefName = async (casePaperName, casePaperId) => {
  try {
    const URL = APIPaths.UPDATE_CASE_PAPER_DEF_NAME;

    const response = await axiosInstance.put(URL, null, {
      params: {
        name: casePaperName,
        id: casePaperId,
      },
    });

    if (response.status === 200) {
      return response;
    } else {
      toast.error(response);
      return [];
    }
  } catch (error) {
    toast.error(error.response.data.message);
    return [];
  }
};

export const deleteAddedCasePaperById = async (id) => {
  try {
    const URL = APIPaths.DELETE_ADDED_CASE_PAPER_BY_ID + id;
    const response = await axiosInstance.delete(URL);

    if (response.status === 200) {
      toast.success(response.data.message);
      return response.data;
    } else {
      toast.error("Something Went Wrong");
      return null;
    }
  } catch (error) {
    if (error.response.data) {
      return toast.error(error.response.data);
    } else {
      toast.error("failed.");
    }
  }
};

export const addOptions = async (questionId, option) => {
  try {
    const response = await axiosInstance.put(
      `${APIPaths.ADD_QUESTION_OPTION}/${questionId}`,
      { option },
    );

    if (response.status === 200) {
      return response;
    } else {
      toast.error(response.data || "Unexpected error");
      return response;
    }
  } catch (error) {
    if (error.response?.data?.errors) {
      for (const key in error.response.data.errors) {
        toast.error(error.response.data.errors[key]);
      }
    } else if (error.response?.data?.message) {
      toast.error(error.response.data.message);
    } else {
      toast.error(error.message || "Unknown error");
    }
  }
};

export const getVasScaleImage = async (id) => {
  try {
    const response = await axiosInstance.get(
      `${APIPaths.GET_VAS_SCALE_IMAGE_BY_ID}/${id}`,
      { responseType: "arraybuffer" },
    );

    if (response && response.data) {
      const blob = new Blob([response.data], { type: "image/jpeg" });
      const imageUrl = URL.createObjectURL(blob);
      return imageUrl;
    }

    return null;
  } catch (error) {
    return null;
  }
};

export const downloadCombinedCasePaperPDF = async ({
  payload,
  category,
  organizationId,
}) => {
  try {
    const URL = `${APIPaths.DOWNLOAD_COMBINED_CASE_PAPER_PDF_BY_CATEGORY}/${category}/${organizationId}`;

    const response = await axiosInstance.post(URL, payload, {
      responseType: "arraybuffer",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/pdf",
      },
    });

    if (response.status === 200) {
      toast.success("Case Paper PDF Downloaded Successfully");
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/pdf" }),
      );
      return url;
    } else if (response.status === 204) {
      toast.warning("Case Paper Not Available");
    }
  } catch (error) {
    toast.error("Case Paper PDF Download failed");
  }
};

export const getCasePapersByClientId = async (id, data) => {
  try {
    const URL = `${APIPaths.GET_CASE_PAPERS_BY_CLIENT_ID}/${id}`;
    const response = await axiosInstance.get(URL, {
      params: {
        casePaperFilterDto: data,
      },
    });

    if (response.status === 200) {
      return response.data;
    }

    return [];
  } catch (error) {}
};

export const getRomRanges = async (joint, motion) => {
  try {
    const URL = APIPaths.GET_ROM_RANGES_BY_JOINT_AND_MOTION;
    const response = await axiosInstance.get(URL, {
      params: {
        joint: joint,
        motion: motion,
      },
    });

    if (response.status === 200) {
      return response;
    }
  } catch (error) {
    toast.error(error.response.data);
    return [];
  }
};


export const downloadAppointmentProgressReport = async (data) => {
  try {
    const URL = APIPaths.APPOINTMENT_PROGRESS_REPORT;
    const response = await axiosInstance.post(URL, data, {
      responseType: "arraybuffer",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    if (response.status === 200) {
      toast.success("File downloaded successfully");
      const url = window.URL.createObjectURL(new Blob([response.data]));
      return url;
    } else if (response.status === 204) {
      toast.warning(
        "No data found for selected date range. Please adjust date range or other selection criteria."
      );
    }
  } catch (error) {
    try {
      const decodedString = new TextDecoder().decode(error.response.data);
      const parsedError = JSON.parse(decodedString);

      toast.error(parsedError?.message || "File download failed");
    } catch (decodeError) {
      toast.error("File download failed due to unexpected error");
      console.error("Decode error:", decodeError);
    }
    console.error("Axios error:", error.response);
  }
};

